// SocialCheck / KEWAG Control OS — UI translations (DE / FR / IT / EN)
export const LANGS = [
  { code: "de", label: "DE" },
  { code: "fr", label: "FR" },
  { code: "it", label: "IT" },
  { code: "en", label: "EN" },
];

export const translations = {
  de: {
    login: {
      brandSub: "Growth OS · KEWAG Control OS",
      claim: { l1: "Inhalte planen.", l2: "Freigeben.", l3: "Live gehen." },
      tagline: "Die professionelle Lösung für Social-Media-Freigabe und Publishing – für KMU und Unternehmen.",
      dash: {
        nav: ["Übersicht", "Beiträge", "Freigaben", "Kalender", "Berichte", "Medien", "Kanäle", "Einstellungen"],
        userRole: "Administrator",
        title: "Übersicht",
        subtitle: "Zentrale Steuerung",
        dateRange: "26. Mai – 1. Juni 2025",
        last7: "Letzte 7 Tage",
        kpis: ["Geplante Beiträge", "Zur Freigabe", "Live-Beiträge", "Monatsberichte"],
        ampelTitle: "Ampel-Übersicht",
        ampel: ["Entwurf", "Zur Freigabe", "Freigegeben"],
        showAll: "Alle Beiträge anzeigen",
        upcoming: "Nächste Beiträge",
        colPost: "Beitrag",
        colChannel: "Kanal",
        colStatus: "Status",
        colWhen: "Geplant für",
        toCalendar: "Zum Kalender",
        status: { draft: "Entwurf", review: "Zur Freigabe", approved: "Freigegeben" },
        posts: [
          { title: "Produktivität steigern im Team", when: "27. Mai, 09:00" },
          { title: "Ein Blick hinter die Kulissen", when: "27. Mai, 12:30" },
          { title: "Neues Projekt: Startschuss", when: "28. Mai, 08:00" },
          { title: "Tipps für effizientes Arbeiten", when: "29. Mai, 10:00" },
        ],
        wpSiteLabel: "WordPress Webseite:",
        wpSiteSub: "Information & Verkauf",
        appLabel: "KEWAG App:",
        appSub: "Freigaben, Planung & Veröffentlichung",
      },
      welcome: "Bei SocialCheck anmelden",
      welcomeSub: "Für KEWAG-Team und bestehende Kunden",
      mobile: {
        segJury: "Jury-Demo",
        segLogin: "Anmelden",
        juryBadge: "JURY-DEMO",
        juryHeadline: "SocialCheck in 5 Stationen erleben",
        juryText: "Beiträge prüfen, per Ampel entscheiden, Kalender und Report testen sowie SocialCheck Pocket entdecken.",
        stations: ["Übersicht", "Beiträge", "Ampel", "Kalender", "Pocket"],
        trust3: ["Ohne Passwort", "Isolierte Demo-Daten", "Keine externe Veröffentlichung"],
        moreSecurity: "Mehr zur Sicherheit",
        securityText: "Diese Wettbewerbs-Demo verwendet ausschliesslich isolierte Beispieldaten. Externe Veröffentlichungen sind serverseitig deaktiviert.",
        juryCta: "Jury-Demo jetzt öffnen",
        juryCtaLoading: "Wird geöffnet…",
        juryCtaSub: "Ungefähr 5 Minuten · Kein Login erforderlich",
        loginTitle: "Willkommen zurück",
        loginSub: "Für KEWAG-Team und bestehende Kunden",
        loginCta: "Sicher anmelden",
        juryMemberQ: "Mitglied der Jury?",
        juryOpenNoPw: "Jury-Demo ohne Passwort öffnen",
        showPwAria: "Passwort anzeigen",
        hidePwAria: "Passwort verbergen",
        langAria: "Sprache wählen",
        stationsAria: "Fünf Stationen der geführten Tour",
        swipeHint: "Wischen für alle 5 Stationen",
      },
      jury: {
        badge: "JURY-DEMO · GEFÜHRTER RUNDGANG",
        title: "SocialCheck in 5 Stationen live erleben",
        desc: "Testen Sie Beiträge, Ampel-Freigaben, Kommentare, Kalender, Monatsreport und SocialCheck Pocket – sofort, sicher und ohne Passwort.",
        primary: "Jury-Demo jetzt öffnen",
        secondary: "So funktioniert SocialCheck",
        duration: "Dauer: ungefähr 5 Minuten",
        stations: ["Übersicht", "Beiträge", "Freigaben/Ampel", "Kalender & Report", "SocialCheck Pocket"],
        trust: [
          "Kein Passwort erforderlich",
          "Nur isolierte Demo-Daten",
          "DE / FR / IT / EN",
          "Keine externen Veröffentlichungen",
          "Kein Zugriff auf echte Kunden",
          "Desktop und Mobile",
        ],
        security: "Diese Wettbewerbs-Demo verwendet ausschliesslich isolierte Beispieldaten. Externe Veröffentlichungen sind serverseitig deaktiviert.",
        fallbackQ: "Mitglied der Jury?",
        fallbackCta: "Jury-Demo ohne Passwort öffnen",
      },
      rememberMe: "Angemeldet bleiben",
      liveExperience: "Sie möchten SocialCheck live erleben?",
      demoOrHelp: "Demo anfordern oder Hilfe erhalten",
      emailLabel: "E-Mail-Adresse",
      loginBtn: "Einloggen",
      demoCta: "Demo anfordern",
      orWord: "oder",
      helpCta: "Hilfe erhalten",
      hl1: "Social Media einfach freigeben.",
      hl2: ["Mehr ", "Übersicht", ". Weniger ", "Aufwand", "."],
      body1: "KEWAG erstellt Inhalte. Sie prüfen Beiträge, Bilder und Texte in einer klaren App.",
      body2: "Für Schweizer KMU, Teams und lokale Betriebe.",
      features2: [
        { title: "Ampel-Freigabe", sub: "Klare Freigaben" },
        { title: "Social-Kalender", sub: "Alles im Blick" },
        { title: "Monatsbericht", sub: "Klare Auswertungen" },
        { title: "Schweizer Datenschutz", sub: "Sicher & DSG-konform" },
        { title: "Mehrsprachig", sub: "DE / FR / IT / EN" },
      ],
      trustTitle: "Vertrauen, Sicherheit, Effizienz.",
      features: [
        { title: "Ampel-Freigabe", desc: "Klarer Freigabeprozess mit Ampel-System für maximale Kontrolle." },
        { title: "Social-Kalender", desc: "Redaktionsplanung und Übersicht für alle Kanäle und Teams." },
        { title: "Monatsreport", desc: "Aussagekräftige Reports für bessere Entscheidungen und Nachweise." },
        { title: "Schweizer Datenschutz", desc: "Ihre Daten bleiben in der Schweiz – sicher und DSG-konform." },
      ],
      subline:
        "Das Ampel-System für Social-Media-Freigaben, Kunden-Cockpit und KEWAG Control OS.",
      ampel: {
        red: { label: "Rot", desc: "Entwurf" },
        amber: { label: "Orange", desc: "zur Freigabe" },
        green: { label: "Grün", desc: "live" },
      },
      trust: ["Sicherer Zugriff", "Schweizer KMU", "Mandantenfähig", "DSG-konform"],
      mockup: { approvals: "Ampel-Freigaben", cockpit: "Kunden-Cockpit", report: "Monatsreport", pdf: "PDF bereit" },
      title: "Willkommen zurück bei SocialCheck",
      subtitle:
        "Melden Sie sich an, um Freigaben, Inhalte, Reports und Kundenprozesse zu verwalten.",
      email: "E-Mail",
      password: "Passwort",
      signIn: "Anmelden",
      signingIn: "Anmeldung läuft…",
      twofa: {
        title: "Bestätigung in zwei Schritten",
        sub: "Geben Sie den 6-stelligen Code aus Ihrer Authenticator-App ein.",
        label: "Authenticator-Code",
        placeholder: "123456 oder Backup-Code",
        hint: "Kein Zugriff auf die App? Nutzen Sie einen Ihrer einmaligen Backup-Codes.",
        verify: "Anmelden",
        checking: "Wird geprüft…",
        back: "Zurück zur Anmeldung",
        tooMany: "Zu viele Fehlversuche. Bitte erneut anmelden.",
        invalid: "Code ungültig. Bitte erneut versuchen.",
      },
      forgot: "Passwort vergessen?",
      forgotTitle: "Passwort zurücksetzen",
      forgotBody:
        "Der automatische Passwort-Reset per E-Mail wird derzeit sicher eingerichtet. Bitte wenden Sie sich für die Wiederherstellung Ihres Zugangs an den KEWAG-Support. Aus Sicherheitsgründen werden keine Passwörter oder Reset-Links per Chat versendet.",
      forgotButton: "Support kontaktieren",
      noAccess: "Noch kein Zugang?",
      requestDemo: "Demo anfragen",
      viewPricing: "Preise & Pakete ansehen",
      security:
        "Zugriff nur für berechtigte Kunden, KEWAG-Team und Administratoren.",
      rolesHint: "Rollenbasierter Zugriff je nach Konto",
      roles: ["Kunden-Cockpit", "KEWAG Team", "Super Admin"],
      encrypted: "Verschlüsselte Verbindung · Geschützter Kundenbereich",
      poweredBy: "Powered by KEWAG & Partner GmbH",
      err: {
        invalid: "E-Mail oder Passwort ist nicht korrekt.",
        notActivated: "Ihr Zugang ist noch nicht aktiviert.",
        blocked: "Ihr Konto wurde gesperrt. Bitte kontaktieren Sie den Support.",
        expired: "Ihre Sitzung ist abgelaufen. Bitte melden Sie sich erneut an.",
        generic: "Anmeldung derzeit nicht möglich. Bitte später erneut versuchen.",
      },
    },
  },
  fr: {
    login: {
      brandSub: "Growth OS · KEWAG Control OS",
      claim: { l1: "Planifier les contenus.", l2: "Valider.", l3: "Publier." },
      tagline: "La solution professionnelle pour la validation et la publication social media – pour PME et entreprises.",
      dash: {
        nav: ["Aperçu", "Publications", "Validations", "Calendrier", "Rapports", "Médias", "Canaux", "Réglages"],
        userRole: "Administrateur",
        title: "Aperçu",
        subtitle: "Pilotage central",
        dateRange: "26 mai – 1 juin 2025",
        last7: "7 derniers jours",
        kpis: ["Publications planifiées", "À valider", "Publications en ligne", "Rapports mensuels"],
        ampelTitle: "Aperçu des feux",
        ampel: ["Brouillon", "À valider", "Validé"],
        showAll: "Voir toutes les publications",
        upcoming: "Prochaines publications",
        colPost: "Publication",
        colChannel: "Canal",
        colStatus: "Statut",
        colWhen: "Planifié pour",
        toCalendar: "Vers le calendrier",
        status: { draft: "Brouillon", review: "À valider", approved: "Validé" },
        posts: [
          { title: "Booster la productivité en équipe", when: "27 mai, 09:00" },
          { title: "Un regard en coulisses", when: "27 mai, 12:30" },
          { title: "Nouveau projet : coup d’envoi", when: "28 mai, 08:00" },
          { title: "Conseils pour travailler efficacement", when: "29 mai, 10:00" },
        ],
        wpSiteLabel: "Site WordPress :",
        wpSiteSub: "Information & vente",
        appLabel: "App KEWAG :",
        appSub: "Validations, planification & publication",
      },
      welcome: "Se connecter à SocialCheck",
      welcomeSub: "Pour l'équipe KEWAG et les clients existants",
      mobile: {
        segJury: "Démo jury",
        segLogin: "Connexion",
        juryBadge: "DÉMO JURY",
        juryHeadline: "Découvrir SocialCheck en 5 étapes",
        juryText: "Vérifier les publications, décider via les feux, tester le calendrier et le rapport, puis découvrir SocialCheck Pocket.",
        stations: ["Aperçu", "Publications", "Feux", "Calendrier", "Pocket"],
        trust3: ["Sans mot de passe", "Données démo isolées", "Aucune publication externe"],
        moreSecurity: "Plus sur la sécurité",
        securityText: "Cette démo de concours utilise uniquement des données d'exemple isolées. Les publications externes sont désactivées côté serveur.",
        juryCta: "Ouvrir la démo jury",
        juryCtaLoading: "Ouverture…",
        juryCtaSub: "Environ 5 minutes · Sans connexion",
        loginTitle: "Bon retour",
        loginSub: "Pour l'équipe KEWAG et les clients existants",
        loginCta: "Se connecter en sécurité",
        juryMemberQ: "Membre du jury ?",
        juryOpenNoPw: "Ouvrir la démo jury sans mot de passe",
        showPwAria: "Afficher le mot de passe",
        hidePwAria: "Masquer le mot de passe",
        langAria: "Choisir la langue",
        stationsAria: "Cinq étapes de la visite guidée",
        swipeHint: "Balayez pour voir les 5 étapes",
      },
      jury: {
        badge: "DÉMO DU JURY · VISITE GUIDÉE",
        title: "Découvrez SocialCheck en direct en 5 étapes",
        desc: "Testez les publications, les validations par feu de signalisation, les commentaires, le calendrier, le rapport mensuel et SocialCheck Pocket – immédiatement, en toute sécurité et sans mot de passe.",
        primary: "Ouvrir la démo du jury",
        secondary: "Découvrir le fonctionnement de SocialCheck",
        duration: "Durée : environ 5 minutes",
        stations: ["Aperçu", "Publications", "Validations/Feu", "Calendrier & rapport", "SocialCheck Pocket"],
        trust: [
          "Aucun mot de passe requis",
          "Uniquement des données de démo isolées",
          "DE / FR / IT / EN",
          "Aucune publication externe",
          "Aucun accès aux vrais clients",
          "Ordinateur et mobile",
        ],
        security: "Cette démo de concours utilise exclusivement des données d'exemple isolées. Les publications externes sont désactivées côté serveur.",
        fallbackQ: "Membre du jury ?",
        fallbackCta: "Ouvrir la démo du jury sans mot de passe",
      },
      rememberMe: "Rester connecté",
      liveExperience: "Vous souhaitez découvrir SocialCheck en direct ?",
      demoOrHelp: "Demander une démo ou obtenir de l’aide",
      emailLabel: "Adresse e-mail",
      loginBtn: "Se connecter",
      demoCta: "Demander une démo",
      orWord: "ou",
      helpCta: "obtenir de l’aide",
      hl1: "Validez vos réseaux sociaux, simplement.",
      hl2: ["Plus de ", "clarté", ". Moins d’", "efforts", "."],
      body1: "KEWAG crée les contenus. Vous validez publications, images et textes dans une app claire.",
      body2: "Pour PME, équipes et commerces locaux suisses.",
      features2: [
        { title: "Validation par feux", sub: "Validations claires" },
        { title: "Calendrier social", sub: "Tout en un coup d’œil" },
        { title: "Rapport mensuel", sub: "Analyses claires" },
        { title: "Protection des données CH", sub: "Sûr & conforme LPD" },
        { title: "Multilingue", sub: "DE / FR / IT / EN" },
      ],
      trustTitle: "Confiance, sécurité, efficacité.",
      features: [
        { title: "Validation par feux", desc: "Processus de validation clair avec système de feux pour un contrôle maximal." },
        { title: "Calendrier social", desc: "Planification éditoriale et vue d’ensemble pour tous les canaux et équipes." },
        { title: "Rapport mensuel", desc: "Des rapports pertinents pour de meilleures décisions et justificatifs." },
        { title: "Protection des données suisse", desc: "Vos données restent en Suisse – sûres et conformes à la LPD." },
      ],
      subline:
        "Le système de feux pour les validations social media, le cockpit client et KEWAG Control OS.",
      ampel: {
        red: { label: "Rouge", desc: "brouillon" },
        amber: { label: "Orange", desc: "à valider" },
        green: { label: "Vert", desc: "en ligne" },
      },
      trust: ["Accès sécurisé", "PME suisses", "Multi-mandant", "Conforme LPD"],
      mockup: { approvals: "Validations", cockpit: "Cockpit client", report: "Rapport mensuel", pdf: "PDF prêt" },
      title: "Bon retour sur SocialCheck",
      subtitle:
        "Connectez-vous pour gérer les validations, contenus, rapports et processus clients.",
      email: "E-mail",
      password: "Mot de passe",
      signIn: "Se connecter",
      signingIn: "Connexion…",
      twofa: {
        title: "Vérification en deux étapes",
        sub: "Saisissez le code à 6 chiffres de votre application d'authentification.",
        label: "Code d'authentification",
        placeholder: "123456 ou code de secours",
        hint: "Pas d'accès à l'application ? Utilisez l'un de vos codes de secours à usage unique.",
        verify: "Se connecter",
        checking: "Vérification…",
        back: "Retour à la connexion",
        tooMany: "Trop de tentatives. Veuillez vous reconnecter.",
        invalid: "Code invalide. Veuillez réessayer.",
      },
      forgot: "Mot de passe oublié ?",
      forgotTitle: "Réinitialiser le mot de passe",
      forgotBody:
        "La réinitialisation automatique du mot de passe par e-mail est en cours de mise en place sécurisée. Pour restaurer votre accès, veuillez contacter le support KEWAG. Pour des raisons de sécurité, aucun mot de passe ni lien de réinitialisation n'est envoyé par chat.",
      forgotButton: "Contacter le support",
      noAccess: "Pas encore d’accès ?",
      requestDemo: "Demander une démo",
      viewPricing: "Voir les prix & forfaits",
      security:
        "Accès réservé aux clients autorisés, à l’équipe KEWAG et aux administrateurs.",
      rolesHint: "Accès basé sur les rôles selon le compte",
      roles: ["Cockpit client", "Équipe KEWAG", "Super Admin"],
      encrypted: "Connexion chiffrée · Espace client protégé",
      poweredBy: "Powered by KEWAG & Partner GmbH",
      err: {
        invalid: "L’e-mail ou le mot de passe est incorrect.",
        notActivated: "Votre accès n’est pas encore activé.",
        blocked: "Votre compte a été bloqué. Veuillez contacter le support.",
        expired: "Votre session a expiré. Veuillez vous reconnecter.",
        generic: "Connexion impossible pour le moment. Veuillez réessayer plus tard.",
      },
    },
  },
  it: {
    login: {
      brandSub: "Growth OS · KEWAG Control OS",
      claim: { l1: "Pianificare contenuti.", l2: "Approvare.", l3: "Andare online." },
      tagline: "La soluzione professionale per approvazione e pubblicazione social media – per PMI e aziende.",
      dash: {
        nav: ["Panoramica", "Post", "Approvazioni", "Calendario", "Report", "Media", "Canali", "Impostazioni"],
        userRole: "Amministratore",
        title: "Panoramica",
        subtitle: "Controllo centrale",
        dateRange: "26 mag – 1 giu 2025",
        last7: "Ultimi 7 giorni",
        kpis: ["Post pianificati", "Da approvare", "Post online", "Report mensili"],
        ampelTitle: "Panoramica semaforo",
        ampel: ["Bozza", "Da approvare", "Approvato"],
        showAll: "Mostra tutti i post",
        upcoming: "Prossimi post",
        colPost: "Post",
        colChannel: "Canale",
        colStatus: "Stato",
        colWhen: "Pianificato per",
        toCalendar: "Al calendario",
        status: { draft: "Bozza", review: "Da approvare", approved: "Approvato" },
        posts: [
          { title: "Aumentare la produttività del team", when: "27 mag, 09:00" },
          { title: "Uno sguardo dietro le quinte", when: "27 mag, 12:30" },
          { title: "Nuovo progetto: si parte", when: "28 mag, 08:00" },
          { title: "Consigli per lavorare in modo efficiente", when: "29 mag, 10:00" },
        ],
        wpSiteLabel: "Sito WordPress:",
        wpSiteSub: "Informazioni & vendita",
        appLabel: "App KEWAG:",
        appSub: "Approvazioni, pianificazione & pubblicazione",
      },
      welcome: "Accedi a SocialCheck",
      welcomeSub: "Per il team KEWAG e i clienti esistenti",
      mobile: {
        segJury: "Demo giuria",
        segLogin: "Accedi",
        juryBadge: "DEMO GIURIA",
        juryHeadline: "Scopri SocialCheck in 5 tappe",
        juryText: "Verifica i post, decidi con il semaforo, prova calendario e report e scopri SocialCheck Pocket.",
        stations: ["Panoramica", "Post", "Semaforo", "Calendario", "Pocket"],
        trust3: ["Senza password", "Dati demo isolati", "Nessuna pubblicazione esterna"],
        moreSecurity: "Più sulla sicurezza",
        securityText: "Questa demo del concorso utilizza esclusivamente dati di esempio isolati. Le pubblicazioni esterne sono disattivate lato server.",
        juryCta: "Apri la demo giuria",
        juryCtaLoading: "Apertura…",
        juryCtaSub: "Circa 5 minuti · Nessun accesso richiesto",
        loginTitle: "Bentornato",
        loginSub: "Per il team KEWAG e i clienti esistenti",
        loginCta: "Accedi in sicurezza",
        juryMemberQ: "Membro della giuria?",
        juryOpenNoPw: "Apri la demo giuria senza password",
        showPwAria: "Mostra password",
        hidePwAria: "Nascondi password",
        langAria: "Scegli la lingua",
        stationsAria: "Cinque tappe della visita guidata",
        swipeHint: "Scorri per tutte le 5 tappe",
      },
      jury: {
        badge: "DEMO PER LA GIURIA · TOUR GUIDATO",
        title: "Scoprite SocialCheck dal vivo in 5 tappe",
        desc: "Provate i contenuti, le approvazioni a semaforo, i commenti, il calendario, il rapporto mensile e SocialCheck Pocket – subito, in sicurezza e senza password.",
        primary: "Apri la demo per la giuria",
        secondary: "Scopri come funziona SocialCheck",
        duration: "Durata: circa 5 minuti",
        stations: ["Panoramica", "Post", "Approvazioni/Semaforo", "Calendario & report", "SocialCheck Pocket"],
        trust: [
          "Nessuna password richiesta",
          "Solo dati demo isolati",
          "DE / FR / IT / EN",
          "Nessuna pubblicazione esterna",
          "Nessun accesso ai clienti reali",
          "Desktop e mobile",
        ],
        security: "Questa demo per il concorso utilizza esclusivamente dati di esempio isolati. Le pubblicazioni esterne sono disattivate lato server.",
        fallbackQ: "Membro della giuria?",
        fallbackCta: "Apri la demo per la giuria senza password",
      },
      rememberMe: "Resta connesso",
      liveExperience: "Vuoi vedere SocialCheck dal vivo?",
      demoOrHelp: "Richiedi una demo o ricevi assistenza",
      emailLabel: "Indirizzo e-mail",
      loginBtn: "Accedi",
      demoCta: "Richiedi una demo",
      orWord: "o",
      helpCta: "ricevi assistenza",
      hl1: "Approva i social, in modo semplice.",
      hl2: ["Più ", "chiarezza", ". Meno ", "fatica", "."],
      body1: "KEWAG crea i contenuti. Tu approvi post, immagini e testi in un’app chiara.",
      body2: "Per PMI, team e attività locali svizzere.",
      features2: [
        { title: "Approvazione a semaforo", sub: "Approvazioni chiare" },
        { title: "Calendario social", sub: "Tutto a colpo d’occhio" },
        { title: "Report mensile", sub: "Analisi chiare" },
        { title: "Protezione dati CH", sub: "Sicuro & conforme LPD" },
        { title: "Multilingue", sub: "DE / FR / IT / EN" },
      ],
      trustTitle: "Fiducia, sicurezza, efficienza.",
      features: [
        { title: "Approvazione a semaforo", desc: "Processo di approvazione chiaro con sistema a semaforo per il massimo controllo." },
        { title: "Calendario social", desc: "Pianificazione editoriale e panoramica per tutti i canali e team." },
        { title: "Report mensile", desc: "Report significativi per decisioni migliori e prove documentali." },
        { title: "Protezione dati svizzera", desc: "I tuoi dati restano in Svizzera – sicuri e conformi alla LPD." },
      ],
      subline:
        "Il sistema a semaforo per approvazioni social, cockpit clienti e KEWAG Control OS.",
      ampel: {
        red: { label: "Rosso", desc: "bozza" },
        amber: { label: "Arancione", desc: "da approvare" },
        green: { label: "Verde", desc: "online" },
      },
      trust: ["Accesso sicuro", "PMI svizzere", "Multi-tenant", "Conforme LPD"],
      mockup: { approvals: "Approvazioni", cockpit: "Cockpit clienti", report: "Report mensile", pdf: "PDF pronto" },
      title: "Bentornato su SocialCheck",
      subtitle:
        "Accedi per gestire approvazioni, contenuti, report e processi clienti.",
      email: "E-mail",
      password: "Password",
      signIn: "Accedi",
      signingIn: "Accesso in corso…",
      twofa: {
        title: "Verifica in due passaggi",
        sub: "Inserisci il codice a 6 cifre della tua app di autenticazione.",
        label: "Codice di autenticazione",
        placeholder: "123456 o codice di backup",
        hint: "Nessun accesso all'app? Usa uno dei tuoi codici di backup monouso.",
        verify: "Accedi",
        checking: "Verifica in corso…",
        back: "Torna all'accesso",
        tooMany: "Troppi tentativi. Accedi di nuovo.",
        invalid: "Codice non valido. Riprova.",
      },
      forgot: "Password dimenticata?",
      forgotTitle: "Reimposta la password",
      forgotBody:
        "Il ripristino automatico della password via e-mail è attualmente in fase di configurazione sicura. Per ripristinare il tuo accesso, contatta il supporto KEWAG. Per motivi di sicurezza, nessuna password o link di reimpostazione viene inviato via chat.",
      forgotButton: "Contatta il supporto",
      noAccess: "Non hai ancora accesso?",
      requestDemo: "Richiedi una demo",
      viewPricing: "Vedi prezzi & pacchetti",
      security:
        "Accesso riservato a clienti autorizzati, al team KEWAG e agli amministratori.",
      rolesHint: "Accesso basato sui ruoli in base all’account",
      roles: ["Cockpit clienti", "Team KEWAG", "Super Admin"],
      encrypted: "Connessione cifrata · Area clienti protetta",
      poweredBy: "Powered by KEWAG & Partner GmbH",
      err: {
        invalid: "E-mail o password non corretti.",
        notActivated: "Il tuo accesso non è ancora attivato.",
        blocked: "Il tuo account è stato bloccato. Contatta il supporto.",
        expired: "La sessione è scaduta. Accedi di nuovo.",
        generic: "Accesso non possibile al momento. Riprova più tardi.",
      },
    },
  },
  en: {
    login: {
      brandSub: "Growth OS · KEWAG Control OS",
      claim: { l1: "Plan content.", l2: "Approve.", l3: "Go live." },
      tagline: "The professional solution for social media approval and publishing – for SMEs and enterprises.",
      dash: {
        nav: ["Overview", "Posts", "Approvals", "Calendar", "Reports", "Media", "Channels", "Settings"],
        userRole: "Administrator",
        title: "Overview",
        subtitle: "Central control",
        dateRange: "May 26 – Jun 1, 2025",
        last7: "Last 7 days",
        kpis: ["Scheduled posts", "Pending approval", "Live posts", "Monthly reports"],
        ampelTitle: "Traffic-light overview",
        ampel: ["Draft", "Pending approval", "Approved"],
        showAll: "Show all posts",
        upcoming: "Upcoming posts",
        colPost: "Post",
        colChannel: "Channel",
        colStatus: "Status",
        colWhen: "Scheduled for",
        toCalendar: "To calendar",
        status: { draft: "Draft", review: "Pending", approved: "Approved" },
        posts: [
          { title: "Boost team productivity", when: "May 27, 09:00" },
          { title: "A look behind the scenes", when: "May 27, 12:30" },
          { title: "New project: kick-off", when: "May 28, 08:00" },
          { title: "Tips for efficient work", when: "May 29, 10:00" },
        ],
        wpSiteLabel: "WordPress website:",
        wpSiteSub: "Information & sales",
        appLabel: "KEWAG app:",
        appSub: "Approvals, planning & publishing",
      },
      welcome: "Sign in to SocialCheck",
      welcomeSub: "For the KEWAG team and existing customers",
      mobile: {
        segJury: "Jury demo",
        segLogin: "Sign in",
        juryBadge: "JURY DEMO",
        juryHeadline: "Experience SocialCheck in 5 stages",
        juryText: "Review posts, decide via the traffic light, test the calendar and report, and discover SocialCheck Pocket.",
        stations: ["Overview", "Posts", "Traffic light", "Calendar", "Pocket"],
        trust3: ["No password", "Isolated demo data", "No external publishing"],
        moreSecurity: "More on security",
        securityText: "This competition demo uses only isolated sample data. External publishing is disabled server-side.",
        juryCta: "Open jury demo now",
        juryCtaLoading: "Opening…",
        juryCtaSub: "About 5 minutes · No login required",
        loginTitle: "Welcome back",
        loginSub: "For the KEWAG team and existing customers",
        loginCta: "Sign in securely",
        juryMemberQ: "Jury member?",
        juryOpenNoPw: "Open jury demo without password",
        showPwAria: "Show password",
        hidePwAria: "Hide password",
        langAria: "Choose language",
        stationsAria: "Five stages of the guided tour",
        swipeHint: "Swipe for all 5 stages",
      },
      jury: {
        badge: "JURY DEMO · GUIDED TOUR",
        title: "Experience SocialCheck live in 5 stages",
        desc: "Test posts, traffic-light approvals, comments, the calendar, monthly reports and SocialCheck Pocket – instantly, securely and without a password.",
        primary: "Open the jury demo",
        secondary: "See how SocialCheck works",
        duration: "Duration: about 5 minutes",
        stations: ["Overview", "Posts", "Approvals/Traffic light", "Calendar & report", "SocialCheck Pocket"],
        trust: [
          "No password required",
          "Only isolated demo data",
          "DE / FR / IT / EN",
          "No external publishing",
          "No access to real customers",
          "Desktop and mobile",
        ],
        security: "This competition demo uses only isolated sample data. External publishing is disabled server-side.",
        fallbackQ: "Jury member?",
        fallbackCta: "Open the jury demo without a password",
      },
      rememberMe: "Keep me signed in",
      liveExperience: "Want to experience SocialCheck live?",
      demoOrHelp: "Request a demo or get help",
      emailLabel: "Email address",
      loginBtn: "Sign in",
      demoCta: "Request a demo",
      orWord: "or",
      helpCta: "get help",
      hl1: "Approve social media, simply.",
      hl2: ["More ", "clarity", ". Less ", "effort", "."],
      body1: "KEWAG creates the content. You review posts, images and texts in one clear app.",
      body2: "For Swiss SMEs, teams and local businesses.",
      features2: [
        { title: "Traffic-light approval", sub: "Clear approvals" },
        { title: "Social calendar", sub: "Everything at a glance" },
        { title: "Monthly report", sub: "Clear insights" },
        { title: "Swiss data protection", sub: "Secure & DSG-compliant" },
        { title: "Multilingual", sub: "DE / FR / IT / EN" },
      ],
      trustTitle: "Trust, security, efficiency.",
      features: [
        { title: "Traffic-light approval", desc: "Clear approval process with a traffic-light system for maximum control." },
        { title: "Social calendar", desc: "Editorial planning and overview for all channels and teams." },
        { title: "Monthly report", desc: "Meaningful reports for better decisions and documentation." },
        { title: "Swiss data protection", desc: "Your data stays in Switzerland – secure and DSG-compliant." },
      ],
      subline:
        "The traffic-light system for social media approvals, client cockpit and KEWAG Control OS.",
      ampel: {
        red: { label: "Red", desc: "draft" },
        amber: { label: "Orange", desc: "pending approval" },
        green: { label: "Green", desc: "live" },
      },
      trust: ["Secure access", "Swiss SMEs", "Multi-tenant", "DSG compliant"],
      mockup: { approvals: "Approvals", cockpit: "Client cockpit", report: "Monthly report", pdf: "PDF ready" },
      title: "Welcome back to SocialCheck",
      subtitle:
        "Sign in to manage approvals, content, reports and customer workflows.",
      email: "Email",
      password: "Password",
      signIn: "Sign in",
      signingIn: "Signing in…",
      twofa: {
        title: "Two-step verification",
        sub: "Enter the 6-digit code from your authenticator app.",
        label: "Authenticator code",
        placeholder: "123456 or backup code",
        hint: "No access to the app? Use one of your one-time backup codes.",
        verify: "Sign in",
        checking: "Checking…",
        back: "Back to sign in",
        tooMany: "Too many attempts. Please sign in again.",
        invalid: "Invalid code. Please try again.",
      },
      forgot: "Forgot password?",
      forgotTitle: "Reset password",
      forgotBody:
        "Automatic password reset by email is currently being set up securely. To restore your access, please contact KEWAG support. For security reasons, no passwords or reset links are sent via chat.",
      forgotButton: "Contact support",
      noAccess: "No access yet?",
      requestDemo: "Request a demo",
      viewPricing: "View prices & packages",
      security:
        "Access is reserved for authorized customers, the KEWAG team and administrators.",
      rolesHint: "Role-based access depending on the account",
      roles: ["Client cockpit", "KEWAG team", "Super Admin"],
      encrypted: "Encrypted connection · Protected client area",
      poweredBy: "Powered by KEWAG & Partner GmbH",
      err: {
        invalid: "Email or password is incorrect.",
        notActivated: "Your access has not been activated yet.",
        blocked: "Your account has been blocked. Please contact support.",
        expired: "Your session has expired. Please sign in again.",
        generic: "Sign-in is currently unavailable. Please try again later.",
      },
    },
  },
};
